import React from "react";

import * as R from "ramda";

import { Flex, TextArea } from "src/components";

import FloatingLabel from "./FloatingLabel";
import ValidationIcon from "./ValidationIcon";

export default props => (
  <Flex flex="1 0 auto" flexDirection="column" mb={2} {...props.displayProps}>
    <Flex style={{ position: "relative" }}>
      <TextArea
        autoSize={true}
        pb={props.value ? "8px" : 2}
        pt={props.value ? "24px" : 2}
        px={3}
        borderRadius={5}
        flex="1 0 auto"
        title={props.placeholder}
        {...R.omit(
          [
            "error",
            "onTouch",
            "setValue",
            "valid",
            "displayProps",
            "renderHelpText",
          ],
          props
        )}
      />
      <ValidationIcon
        {...props}
        style={{
          position: "absolute",
          right: 20,
          top: 20,
        }}
      />
      {props.value && <FloatingLabel>{props.label}</FloatingLabel>}
    </Flex>
    {props.renderHelpText({
      containerProps: {
        ml: 3,
        mt: 1,
        mb: 2,
      },
    })}
  </Flex>
);



// WEBPACK FOOTER //
// ./src/components/Form/TextArea.js